import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOperatorElearningTopicCategoryVm } from '../operator-elearning-topic-category-vm.model';
@Injectable({ providedIn: 'root' })
export class OperatorElearningTopicCategoriesService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorElearningTopicCategories`;
  }
  get(search?: string, examGuids?: string[]): Observable<IOperatorElearningTopicCategoryVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (search !== undefined && search !== null) {
      params = params.set('search', search);
    }
    if (examGuids !== undefined && examGuids !== null) {
      examGuids.forEach((examGuid) => {
        params = params.append('examGuids', examGuid);
      });
    }
    return this.http.get<IOperatorElearningTopicCategoryVm[]>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
